import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { ESetInitialPageNumberActionType, TSetInitialPageNumber } from './types';
import { ISettings } from '../../../types/settings';

export const setInitialPageNumber: (name: ISettings['initialPageNumber']) => TSetInitialPageNumber = actionGenerator<
  ESetInitialPageNumberActionType.Set,
  ISettings['initialPageNumber']
>(ESetInitialPageNumberActionType.Set);
